import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withTheme } from '@material-ui/core';
import moment from 'moment';
import config from '../config';

export function Event(props) {
  const {
    elephant, event, focused, onSelected, onElephantSelected, x, y, yShift, layer, theme,
  } = props;

  return (
    <React.Fragment>
      <div style={{
        position: 'absolute',
        width: '2px',
        left: `${x}px`,
        top: `${y + yShift}px`,
        height: `${(layer + 1) * config.MAX_EVENT_HEIGHT + (layer + 1) * config.EVENT_MARGIN - yShift}px`,
        backgroundColor: focused ? theme.lifeline.palette.markers.time : 'rgba(0,0,0,0.2)',
        zIndex: 100,
        transform: 'translate(-50%, 0%)',
      }}
      />

      <Paper
        onClick={() => {
          if (focused && event.linkedElephant) onElephantSelected(event.linkedElephant);
          else onSelected(event);
        }}
        style={{
          maxWidth: `${config.MAX_EVENT_WIDTH}px`,
          maxHeight: `${config.MAX_EVENT_HEIGHT}px`,
          padding: '7px',
          paddingTop: '5px',
          fontSize: '0.85em',
          borderRadius: '3px',
          position: 'absolute',
          left: `${x}px`,
          top: `${y + yShift}px`,
          transform: 'translate(-50%)',
          cursor: 'pointer',
          zIndex: focused ? 201 : 200,
          boxShadow: focused ? `0 0 1px 2px ${theme.lifeline.palette.markers.time}` : '',
        }}
      >
        <Typography style={{ fontSize: '0.85em', color: 'gray' }} variant="body1">
          {event.type === 'estimated_death' ? '' : event.date.format()}
          {event.type !== 'birth' ? ` Age ${event.date.diff(moment(elephant.birth), 'years')}` : ''}
        </Typography>
        <Typography style={{ fontSize: '1.05em', margin: '4px' }} variant="title">
          {event.title}
        </Typography>
        <Typography style={{ fontSize: '0.98em' }} variant="body1">
          {event.details}
        </Typography>
      </Paper>
    </React.Fragment>
  );
}

Event.propTypes = {
  elephant: PropTypes.shape().isRequired,
  event: PropTypes.shape().isRequired,
  focused: PropTypes.bool,
  onSelected: PropTypes.func,
  onElephantSelected: PropTypes.func,
  y: PropTypes.number.isRequired,
  yShift: PropTypes.number.isRequired,
  x: PropTypes.number.isRequired,
  layer: PropTypes.number.isRequired,
  theme: PropTypes.shape().isRequired,
};
Event.defaultProps = {
  focused: false,
  onSelected: () => {},
  onElephantSelected: () => {},
};

export default withTheme()(Event);



// WEBPACK FOOTER //
// ./src/components/lifeline/Events/Event.jsx